<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Новости {{ newsDomain }}</h2>
          <v-btn icon class="mx-3" color="secondary" :disabled="!iseditor || !isadmin" @click="addExpansionPanel()">
            <v-icon>
              add
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-radio-group
            v-model="radioGroup"
            row
            hide-details
          >
            <v-radio label="deti.cdsvyatka.com"></v-radio>
            <v-radio label="ekarta43.ru"></v-radio>
          </v-radio-group>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <template>
          <v-expansion-panels focusable>
            <v-expansion-panel
              v-for="item in newsarticles"
              :key="item.id"
            >
              <v-expansion-panel-header>
                <strong style="width:300px;max-width:300px">
                  {{ item.domains.join(',') }}
                </strong>
                <span align="left">{{ item.title }}</span>
                <span v-if="!item.unsaved" align="right">
                  <pre> <small><b>{{ item.cts.split('T')[0]}}</b></small></pre>
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card flat>
                  <v-card-text>
                    <v-text-field
                      v-model="item.title"
                      label="Заголовок"
                    ></v-text-field>
                    <v-textarea
                      v-model="item.content"
                      label="Основной текст"
                      auto-grow
                    ></v-textarea>
                  </v-card-text>
                  <v-card-title>Превью</v-card-title>
                  <v-card-text
                    v-html="item.content"
                  >
                  </v-card-text>
                  <v-spacer></v-spacer>
                  <v-card-actions>
                    <p><small><strong>created by:</strong> {{ item.createdby }}</small>
                    <br>
                    <small><strong>updated by:</strong> {{ item.updatedby }}</small></p>
                    <v-spacer></v-spacer>
                    <v-checkbox
                      v-model="checkbox1"
                      v-if="item.unsaved"
                      :label="`deti.cdsvyatka.com`"
                    ></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-checkbox
                      v-model="checkbox2"
                      v-if="item.unsaved"
                      :label="`ekarta43.ru`"
                    ></v-checkbox>
                    <v-spacer></v-spacer>
                    <v-btn
                      v-if="!item.unsaved"
                      :disabled="!item.content"
                      fab
                      @click="updateNewsArticle(item)"
                    >
                      <v-icon color="primary">save</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.unsaved"
                      color="primary"
                      fab
                      :disabled="!item.content || !item.title || (!checkbox1 && !checkbox2)"
                      @click="addNewsArticle(item)"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
                <v-spacer></v-spacer>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'NewsArticles',
  data: () => ({
    checkbox1: false,
    checkbox2: false,
    newsarticles: [],
    radioGroup: 0,
    domains: [],
    newsDomain: 'deti.cdsvyatka.com'
  }),
  methods: {
    addExpansionPanel () {
      if (this.newsarticles.filter(x => x.unsaved === true).length === 0) {
        this.newsarticles.unshift({
          title: '',
          content: '',
          domains: [this.domains],
          createdby: this.profile.email,
          unsaved: true
        })
      }
    },
    async fetch () {
      if (this.iseditor || this.isadmin) {
        const { newsarticles } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-newsarticles',
          pl: {
            domains: this.newsDomain
          }
        })
        this.newsarticles = newsarticles
      }
    },
    async addNewsArticle (article) {
      try {
        const { newOne } = await this.$store.dispatch('sioRequest', {
          topic: 'add-newsarticle',
          pl: {
            title: article.title,
            content: article.content,
            ishtml: true,
            domains: this.domains
          }
        })
        this.checkbox1 = false
        this.checkbox2 = false
        this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async updateNewsArticle (article) {
      try {
        const { newsarticles } = await this.$store.dispatch('sioRequest', {
          topic: 'update-newsarticle',
          pl: {
            newsarticleid: article.newsarticleid,
            title: article.title,
            content: article.content,
            ishtml: true,
            cts: article.cts
          }
        })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    iseditor () {
      return this.scopes.includes('editor')
    },
    isadmin () {
      return this.scopes.includes('admin')
    },
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    async radioGroup (val) {
      if (val === 0) {
        this.newsDomain = 'deti.cdsvyatka.com'
      } else
      if (val === 1) {
        this.newsDomain = 'ekarta43.ru'
      }
      this.fetch()
    },
    checkbox1 (val) {
      val ? this.domains.push('deti.cdsvyatka.com') : this.domains = this.domains.filter(x => x !== 'deti.cdsvyatka.com')
    },
    checkbox2 (val) {
      val ? this.domains.push('ekarta43.ru') : this.domains = this.domains.filter(x => x !== 'ekarta43.ru')
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style>
</style>
